import React from "react";
import Overview from "../components/generalInventoryPage/Overview";

export default function GeneralInventoryPage(): JSX.Element {
  return <Overview />;
}
